import { WebhookEventType } from '@/gql/graphql'

export enum WebhookTabs {
    MANAGE = 'manage',
    EVENTS = 'events',
}

// What a staffing agency webhook without a subscription list receives: no hire events.
export const SUPPLIER_NULL_SUBSCRIPTION_EVENT_TYPES: WebhookEventType[] = [
    WebhookEventType.JobShared,
    WebhookEventType.JobShareRemoved,
    WebhookEventType.JobUpdated,
    WebhookEventType.JobClosed,
    WebhookEventType.JobCandidateUpdated,
]

// Every event a staffing agency webhook can receive. Hire events only reach it when listed.
export const SUPPLIER_WEBHOOK_EVENT_TYPES: WebhookEventType[] = [
    ...SUPPLIER_NULL_SUBSCRIPTION_EVENT_TYPES,
    WebhookEventType.ContractAccepted,
    WebhookEventType.HireUpdated,
    WebhookEventType.HireCancelled,
    WebhookEventType.HireTerminated,
    WebhookEventType.HireEnded,
]
